import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { Box, RadioButton, SelectionCard, TextAlpha } from '@yonderland/andes-react';
import LocalStorageUtil from '../../../util/LocalStorageUtil';
import { SHOP_NUMBER_STORAGE_KEY } from '../../../constants/StorageKeysConstants';
import { PaymentGroupContent } from './payment-groups/PaymentGroupContent';
import { usePaymentState } from '../../../context/CheckoutPaymentContext';
import { checkoutMutations } from '@as-react/common-queries';
import { useMutation } from '@tanstack/react-query';
import { useAemConfig } from '@as-react/common-components';
import { generatePathUrl } from '../../../util/URLParamUtil';
import { RoutePathname } from '@as-react/common-types';
const PAY_ON_TILL = 'PAY_ON_TILL';
export const ShoplandingPaymentGroups = () => {
    const { t } = useTranslation(I18N_NAMESPACES.buy);
    const [{ info }] = usePaymentState();
    const { defaultRequestParams, isInAuthorMode, root, servicesEndpoint } = useAemConfig();
    const { postShoplandingPayment } = checkoutMutations({ servicesEndpoint, defaultRequestParams });
    const { mutateAsync: postShoplandingPaymentMutation } = useMutation(postShoplandingPayment);
    const onSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        const storeNumber = LocalStorageUtil.getJsonItem(SHOP_NUMBER_STORAGE_KEY);
        yield postShoplandingPaymentMutation(storeNumber);
        const search = {
            status: 'accept',
            orderID: info.orderReference,
        };
        const location = generatePathUrl(root, `buy/${RoutePathname.CONFIRMATION}.html`, isInAuthorMode, search);
        window.location.href = `${location.pathname}?${location.search}`;
    });
    return (_jsxs(SelectionCard, { id: `shoplanding_${PAY_ON_TILL}`, state: "active", hasGapY: false, testId: `payment_option_${PAY_ON_TILL.toLowerCase()}`, children: [_jsx(SelectionCard.Cell, { section: "media", cellProps: { align: 'stretch' }, children: _jsx(Box, { paddingBlockStart: "0.5", children: _jsx(RadioButton, { id: PAY_ON_TILL, name: "checkout-delivery-options", value: PAY_ON_TILL, checked: true }) }) }), _jsx(SelectionCard.Cell, { section: "header", cellProps: { align: 'center' }, children: _jsx(TextAlpha, { color: "neutral", children: t('buy.confirmation.shop.pay.at.checkout', { orderId: '' }) }) }), _jsx(SelectionCard.Cell, { section: "content", children: _jsx(PaymentGroupContent, { submitButtonText: t('buy.payment.confirm'), selected: true, group: {
                        name: PAY_ON_TILL,
                        ogoneAliases: null,
                        paymentOptions: [],
                        sortOrder: 0,
                        supportsTokenization: false,
                        weight: 0,
                        amountPayableWithOption: null,
                    }, onSubmit: onSubmit }) })] }));
};
